import { useState } from "react";
import { Star } from "lucide-react";

// Interactive (input) OR read-only star rating (1..5).
export default function StarRating({
  value = 0,
  onChange,
  readOnly = false,
  size = 22,
  testid,
}) {
  const [hover, setHover] = useState(0);
  const active = hover || value;

  return (
    <div className="inline-flex items-center gap-1" data-testid={testid} role="radiogroup">
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = n <= active;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange?.(n)}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            data-testid={testid ? `${testid}-star-${n}` : undefined}
            aria-label={`${n} bintang`}
            className={`transition-transform ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110 active:scale-95"}`}
          >
            <Star
              size={size}
              className={filled ? "text-amber-400" : "text-muted-foreground/40"}
              fill={filled ? "currentColor" : "none"}
            />
          </button>
        );
      })}
    </div>
  );
}
